import { useBooleanState } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { MinimalButton } from '@calendly/ui/components/minimal-button'
import { useState, useRef } from 'react'

import { FilterButton } from './filter_button'
import { SearchFilterModal } from './search_filter_modal'
import { searchResetParams, changedSearchFilters } from './utils'

export const SearchFilter = ({ filters, setFilters, searchQuery }) => {
  const [isModalOpen, openModal, closeModal] = useBooleanState(false)
  const [currentFilters, setCurrentFilters] = useState(filters)
  const changedFilters = changedSearchFilters(filters)
  const filterCount = changedFilters.length
  const filterButtonRef = useRef(null)

  const onResetFilters = () => {
    setCurrentFilters(searchResetParams(searchQuery))
    setFilters(searchResetParams(searchQuery))
  }

  return (
    <>
      <FilterButton
        ref={filterButtonRef}
        isModalOpen={isModalOpen}
        openModal={openModal}
        closeModal={closeModal}
        filterCount={filterCount}
      />
      {filterCount > 0 && (
        <MinimalButton onClick={onResetFilters}>
          {I18n.t('publisher.scheduling.shared.empty_state.filter.button.clear')}
        </MinimalButton>
      )}
      <SearchFilterModal
        isOpen={isModalOpen}
        onClose={closeModal}
        filters={filters}
        setFilters={setFilters}
        searchQuery={searchQuery}
        resetParams={searchResetParams(searchQuery)}
        currentFilters={currentFilters}
        setCurrentFilters={setCurrentFilters}
        triggerRef={filterButtonRef}
      />
    </>
  )
}
